import Vue from 'vue'
import Router from 'vue-router'
import Setup from './views/Setup.vue'
import Login from './views/Login.vue'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/setup/:equipmentId?/:secret?/:disableVirtualKeyboard?',
      name: 'setup',
      component: Setup
    },
    {
      path: '/',
      name: 'appLogin',
      component: Login
    },
    {
      path: '/logout',
      name: 'userLogout',
      component: () => {
        store.commit('setUser', null)
        store.commit('setTotemUsage', null)
        router.push('/')
      }
    },
    {
      path: '/change-password',
      name: 'appChangePassword',
      component: () => import('./views/ChangePassword.vue')
    },
    {
      path: '/register',
      name: 'appRegister',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/main',
      name: 'userMain',
      component: () => import('./views/Main.vue')
    },
    {
      path: '/profile',
      name: 'userProfile',
      component: () => import('./views/Profile.vue')
    },
    {
      path: '/profile/change-photo',
      name: 'userProfileChangePhoto',
      component: () => import('./views/ProfileChangePhoto.vue')
    },
    {
      path: '/booking',
      name: 'userBooking',
      component: () => import('./views/Booking.vue')
    },
    {
      path: '/dependent',
      name: 'userDependent',
      component: () => import('./views/Dependent.vue')
    },
    {
      path: '/dependent/add',
      name: 'userDependentAdd',
      component: () => import('./views/DependentAdd.vue')
    },
    {
      path: '/validate-info',
      name: 'validateInfo',
      component: () => import('./views/ValidateInfo.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name && to.name.startsWith('app')) {
    if (!(store.getters.getCredentialUser && store.getters.getCredentialApp)) {
      router.push('/setup')
    }
  }

  if (to.name && to.name.startsWith('user')) {
    if (!store.getters.getUser) {
      router.push('/')
    }
  }
  
  return next()
})

export default router